import React from 'react';
import { Box } from '@mui/material';

interface ContainerNoScrollProps {
    children: React.ReactNode;
}

export const ContainerNoScroll = ({ children }: ContainerNoScrollProps) => (
    <Box sx={{ px: { xs: 2, lg: 0 } }}>{children}</Box>
);

export default ContainerNoScroll;
